import styled from "@emotion/styled";
import { motion } from "motion/react";
import { MDSSessionList } from "@/mds/components/sessions/session-list";
import { SessionViewMode } from "../../../sessions/session.constants";
import { MDSSessionConfig, SessionStatus } from "../../session.types";
import { MDSSessionArtifact } from "../../session-context";
import { SessionItem } from "../../session-item";

type Props = {
  sessionItems: SessionItem[];
  sessionId: string;
  sessionStatus: SessionStatus;
  activeArtifact: MDSSessionArtifact | null;
  sessionConfig: MDSSessionConfig;
  sessionViewMode: SessionViewMode;
  containerHeight: number;
  /**
   * Determines if we need to animate the height change of the content.
   * Undefined means we start from scratch.
   */
  prevContainerHeight?: number;
};

export const SessionViewExpandedContent = ({
  sessionItems,
  sessionId,
  sessionStatus,
  activeArtifact,
  sessionConfig,
  sessionViewMode,
  containerHeight,
  prevContainerHeight,
}: Props) => {
  return (
    <ExpandedContent>
      <motion.div
        key="content"
        initial={{ opacity: 0, height: prevContainerHeight || containerHeight }}
        animate={{ opacity: 1, height: containerHeight }}
        transition={{ duration: 0.2, delay: 0.2, ease: [0.4, 0, 0.2, 1] }}
      >
        <Content>
          <SessionContainer>
            <MDSSessionList
              sessionItems={sessionItems}
              sessionId={sessionId}
              sessionStatus={sessionStatus}
              activeArtifact={activeArtifact}
              containerHeight={containerHeight}
              sessionConfig={sessionConfig}
              sessionViewMode={sessionViewMode}
            />
          </SessionContainer>
        </Content>
      </motion.div>
    </ExpandedContent>
  );
};

const Content = styled.div``;

const ExpandedContent = styled.div`
  width: 100%;
`;

export const SessionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 600px;
`;
